export const getRelativeWidthToVW = (offset: number) => `calc(100vw - ${offset}px)`;
